import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { SystemService } from 'src/app/service/system.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  searchOpen: boolean = false;
  currentLang: string = "en";
  semesterDes:any;
  constructor(public globals: Globals, public router: Router, public translate: TranslateService, public systemService: SystemService, public toastrService: ToastrService) { }

  ngOnInit(): void {
    this.currentLang = this.globals.lang;
    this.getAcmSemester();
  }

  toggle() {
    this.globals.menuOpened = !this.globals.menuOpened;
    this.searchOpen = false;
  }

  toggleSearch() {
    this.globals.menuOpened = false;
    this.searchOpen = !this.searchOpen;
  }

  logout() {
    localStorage.clear();
    localStorage.clear();
    this.globals.loggedIn = false;
    this.router.navigate(['/login'], { replaceUrl: true });
    window.location.reload();
  }

  changeLang(lang: string) {
    // console.log("test : " + this.loginForm.controls.lang.value);
    this.currentLang = lang;
    this.globals.changeLang(this.currentLang);
    // setTimeout(() => {
    //   console.log('sleep');
    //   this.translate.use(this.currentLang);
    //   // And any other code that should run only after 1s
    // }, 1000);
    this.translate.use(this.currentLang);

  }

  getAcmSemester() {
    this.systemService.getAcmSemester(this.globals.currentUserInfo.semesterid).subscribe(
      data => {
        this.semesterDes = data;
        // this.toastr.success("Basic Data Saved successfully");
      },
      error => {
        //this.creating = false
        this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
      },
      //() => this.creating = false

    );
  }
}
